module.exports = __webpack_public_path__ + "img/gallery-icon-04.eb07652c.png";